const types = {
  adobeCep: require("./adobeCep").default,
  cli: require("./cli").default,
  executable: require("./executable").default,
  generatorCorePlugin: require("./generatorCorePlugin").default,
  nodeClass: require("./nodeClass").default,
  githubAction: require("./githubAction").default,
  nodeLib: require("./nodeLib").default,
  nodeScript: require("./nodeScript").default,
  universalClass: require("./universalClass").default,
  universalLib: require("./universalLib").default,
  webapp: require("./webapp").default,
  html: require("./html").default,
  reactDomComponent: require("./reactDomComponent").default,
}

export default types